import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { equals, length, slice, toLower, replace, findIndex, propEq, move, clone, remove, filter } from 'ramda';
import Icon from '@components/@core/Icon';
import Pagination from '@components/@core/Pagination';
import Thumbnail from '@components/@core/Thumbnail';
import EditDropdown from '@components/EditDropdown';
import { LibraryTypes } from '~/services/config';

class DocumentList extends Component {
    state = {
        curPage: 1,
        totalPage: 1,
        perPage: 10,
        selected: [],
        documents: [],
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        if (!equals(nextProps.modules, prevState.documents)) {
            const { perPage, curPage } = prevState;
            const from = (curPage - 1) * perPage;
            const to = curPage * perPage;
            const totalPage = Math.ceil(length(nextProps.modules) / perPage);
            const selected = slice(from, to, nextProps.modules);
            return {
                documents: nextProps.modules,
                selected,
                totalPage,
            };
        }
        return null;
    }

    handleChangePage = (page) => {
        const { totalPage, perPage } = this.state;
        const { modules } = this.props;
        if (page > totalPage) return;
        const from = (page - 1) * perPage;
        const to = page * perPage;
        const selected = slice(from, to, modules);
        this.setState({ curPage: page, selected });
    };

    handleSelectMenu = (item) => (e) => {
        const { documents } = this.state;
        const index = findIndex(propEq('id', item.id), documents);
        let modules = clone(documents);
        switch (e) {
            case 'move up':
                modules = move(index, index - 1, modules);
                break;
            case 'move down':
                modules = move(index, index + 1, modules);
                break;
            case 'remove':
                modules = remove(index, 1, modules);
                break;
            default:
                break;
        }
        this.props.onChange(modules);
    };

    render() {
        const { totalPage, perPage, curPage, selected } = this.state;
        return (
            <div className="library-programs-list px-0">
                <div className="programs-module-list">
                    {selected.map((item, index) => {
                        const type = toLower(replace(/\s/g, '', item.data.type));
                        const thumbnail = LibraryTypes[type].icon;
                        let dotsMenu = ['Move Down', 'Move Up', 'Remove'];
                        if (index === 0) {
                            dotsMenu = filter((x) => x !== 'Move Up', dotsMenu);
                        }
                        if (length(selected) === index + 1) {
                            dotsMenu = filter((x) => x !== 'Move Down', dotsMenu);
                        }
                        return (
                            <div className="d-flex jc-between py-2" key={`${item.data.type}-${item.id}`}>
                                <div className="d-flex ai-center">
                                    <Icon name="far fa-circle me-3" size={25} color="#969faa" />
                                    <Thumbnail source={thumbnail} label={item.data.type} size="tiny" />
                                    <div className="ml-3">
                                        <p className="dsl-b14 text-400 mb-1">{item.title}</p>
                                        <p className="dsl-m12 mb-0">Completed: none</p>
                                    </div>
                                </div>
                                <div className="edit">
                                    <EditDropdown options={dotsMenu} onChange={this.handleSelectMenu(item)} />
                                </div>
                            </div>
                        );
                    })}
                    <Pagination current={curPage} per={perPage} total={totalPage} onChange={this.handleChangePage} />
                </div>
            </div>
        );
    }
}

DocumentList.propTypes = {
    modules: PropTypes.array,
};

DocumentList.defaultProps = {
    modules: [],
};

export default DocumentList;
